export const CAMERA_DEVICE_SWITCH_STARTED_EVENT = 'drawclub:camera-device-switch-started';
export const CAMERA_DEVICE_SWITCH_FINISHED_EVENT = 'drawclub:camera-device-switch-finished';
export const CAMERA_DEVICE_TRACK_REFRESHED_EVENT = 'drawclub:camera-device-track-refreshed';

export function dispatchCameraDeviceSwitchStarted() {
  window.dispatchEvent(new CustomEvent(CAMERA_DEVICE_SWITCH_STARTED_EVENT));
}

export function dispatchCameraDeviceSwitchFinished() {
  window.dispatchEvent(new CustomEvent(CAMERA_DEVICE_SWITCH_FINISHED_EVENT));
}

export function dispatchCameraDeviceTrackRefreshed() {
  window.dispatchEvent(new CustomEvent(CAMERA_DEVICE_TRACK_REFRESHED_EVENT));
}
